import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ModalComponent } from '@app/shared/components';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TicketReportStatus } from '@app/shared/models/enums/ticket-report-status';

@Component({
  selector: 'app-tool-ticket-approve-modal',
  templateUrl: './tool-ticket-approve-modal.component.html',
  styleUrls: ['./tool-ticket-approve-modal.component.scss']
})
export class ToolTicketApproveModalComponent implements OnInit {

  @ViewChild(ModalComponent, { static: true }) modal: ModalComponent;
  @Output() confirmEvent = new EventEmitter<any>();
  @Output() cancelEvent = new EventEmitter<any>();

  reportStatus = TicketReportStatus;
  selectedStatus: TicketReportStatus = null;

  form: UntypedFormGroup;
  showValidations = false;

  constructor(private fb: UntypedFormBuilder) {
    this.form = this.fb.group({
      description: ['']
    });
  }

  ngOnInit(): void {}

  open() {
    this.modal.open();
  }

  close() {
    this.modal.close();
    this.resetState();
  }

  isSelected(status: TicketReportStatus): boolean {
    return this.selectedStatus === status;
  }

  onSelectOption(status: TicketReportStatus): void {
    this.selectedStatus = status;
    if (status === TicketReportStatus.ResolvedInternally) {
      this.form.get('description').setValidators(Validators.required);
    } else {
      this.form.get('description').clearValidators();
      this.form.get('description').setValue('');
    }
    this.form.get('description').updateValueAndValidity();
  }

  control(name: string): UntypedFormControl {
    return this.form.get(name) as UntypedFormControl;
  }

  onConfirm(): void {
    if (this.selectedStatus === TicketReportStatus.ResolvedInternally && this.form.invalid) {
      this.showValidations = true;
      return;
    }

    this.showValidations = false;
    this.confirmEvent.emit({
      status: this.selectedStatus,
      description: this.form.get('description').value
    });
    this.close();
  }

  onCancel(): void {
    this.cancelEvent.emit();
    this.close();
  }

  get showReason(): boolean {
    return this.selectedStatus === TicketReportStatus.ResolvedInternally;
  }

  private resetState(): void {
    this.selectedStatus = null;
    this.showValidations = false;
    this.form.reset({ description: '' });
    this.form.get('description').clearValidators();
    this.form.get('description').updateValueAndValidity();
  }
}
